export default __webpack_public_path__ + "static/media/1_0040.184f42e0.webp";